/**
 * @generated SignedSource<<f09efc9c650ce75f4ca778895a0d3ee0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type actions_projectVersions_ActionsCell_jiraProject$data = {
  readonly canEditVersions?: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly id: string;
  readonly key: string;
  readonly " $fragmentType": "actions_projectVersions_ActionsCell_jiraProject";
};
export type actions_projectVersions_ActionsCell_jiraProject$key = {
  readonly " $data"?: actions_projectVersions_ActionsCell_jiraProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"actions_projectVersions_ActionsCell_jiraProject">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isManageVersionsPermissionEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "actions_projectVersions_ActionsCell_jiraProject",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "condition": "isManageVersionsPermissionEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "canEditVersions",
          "args": [
            {
              "kind": "Literal",
              "name": "type",
              "value": "MANAGE_VERSIONS"
            }
          ],
          "concreteType": "JiraProjectAction",
          "kind": "LinkedField",
          "name": "action",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "kind": "ScalarField",
                "name": "canPerform"
              },
              "action": "THROW",
              "path": "canEditVersions.canPerform"
            }
          ],
          "storageKey": "action(type:\"MANAGE_VERSIONS\")"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "d0649a1e75ed2aeb169aade35f2d6e09";

export default node;
